<template>
  <div>
    <v-menu offset-y>
      <template #activator="{ on:onMenu}">
        <v-tooltip bottom>
          <template #activator="{ on: onTooltip }">
            <v-btn
              icon
              v-on="{ ...onMenu, ...onTooltip }"
              :disabled="sendDisabled"
            >
              <v-icon>mdi-send</v-icon>
            </v-btn>
          </template>
          <span>{{ $t('recherche.envoi.menu.title') }}</span>
        </v-tooltip>
      </template>
      <v-list dense>
        <v-list-item @click="open('mail')">
          <v-list-item-icon>
            <v-icon>mdi-email</v-icon>
          </v-list-item-icon>
          <v-list-item-title>{{
            $t('recherche.envoi.title.mail')
          }}</v-list-item-title>
        </v-list-item>
        <v-list-item @click="open('sms')">
          <v-list-item-icon>
            <v-icon>mdi-message</v-icon>
          </v-list-item-icon>
          <v-list-item-title>{{
            $t('recherche.envoi.title.sms')
          }}</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>

    <v-dialog persistent v-model="showDialog" fullscreen>
      <v-toolbar dark color="primary">
        <v-btn icon dark @click="close()">
          <v-icon>mdi-close</v-icon>
        </v-btn>
        <v-toolbar-title>{{
          $t('recherche.envoi.title.' + this.form.typeEnvoi)
        }}</v-toolbar-title>
      </v-toolbar>
      <v-card>
        <v-card-text>
          <v-row dense>
            <v-col cols="12" sm="12">
              <v-radio-group
                v-model="form.typeEnvoi"
                :label="$t('recherche.envoi.form.typeEnvoi')"
                row
                mandatory
              >
                <v-radio
                  v-for="typeEnvoi in typesEnvoi"
                  :key="typeEnvoi"
                  :label="$t('recherche.envoi.form.typesEnvoi.' + typeEnvoi)"
                  :value="typeEnvoi"
                />
              </v-radio-group>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="12">
              <span class="text-body-1">{{
                $t('recherche.envoi.form.list.title')
              }}</span>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="12">
              <v-data-table
                :headers="headers"
                :items="destinataires"
                item-key="id"
                dense
                ref="destinataires"
              >
                <template #item.telephone="{item}">
                  {{ item.telephone }}
                  <v-tooltip v-if="item.telephone" bottom>
                    <template #activator="{ on }">
                      <v-icon v-on="on">{{
                        item.smsAccepte
                          ? 'mdi-cellphone-message'
                          : 'mdi-cellphone-message-off'
                      }}</v-icon>
                    </template>
                    <span>{{
                      item.smsAccepte ? 'SMS accepté' : 'SMS refusé'
                    }}</span>
                  </v-tooltip>
                </template>
                <template #item.status="{item}">
                  <v-icon v-if="item.status == 'ok'" color="primary"
                    >mdi-check</v-icon
                  >
                  <v-icon v-else-if="item.status == 'ko'" color="error"
                    >mdi-window-close</v-icon
                  >
                  <v-icon v-else-if="item.status == 'unknown'">mdi-help</v-icon>
                </template>
              </v-data-table>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="12">
              <span class="text-body-1"
                >{{ $t('recherche.envoi.form.message.title') }}
                {{
                  $tc(
                    'recherche.envoi.form.message.caracteres',
                    this.form.body.length,
                  )
                }}</span
              >
            </v-col>
          </v-row>
          <v-row v-if="subjectVisible">
            <v-col cols="12" md="12">
              <v-text-field
                filled
                :label="$t('recherche.envoi.form.subject')"
                v-model="form.subject"
                :rules="[obligatoireRule()]"
                hide-details="auto"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="12">
              <v-textarea
                filled
                :label="$t('recherche.envoi.form.content')"
                v-model="form.body"
                :rules="[obligatoireRule()]"
                hide-details="auto"
              ></v-textarea>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-btn text @click="quit">
            {{ $t('button.quit') }}
          </v-btn>
          <v-btn text color="primary" @click="send">
            {{ $t('button.send') }}
          </v-btn>

          <v-dialog v-model="waitForSending" persistent max-width="50%">
            <v-card>
              <v-card-title class="accent white--text">
                <v-icon color="white">mdi-clock</v-icon>Envoi en cours
              </v-card-title>
              <v-card-text class="body-1">
                <p class="pt-4">
                  L'envoi est en cours.
                </p>
                <p>
                  Veuillez patienter quelques secondes.
                </p>
                <v-progress-linear
                  color="primary"
                  indeterminate
                  rounded
                  striped
                  height="6"
                ></v-progress-linear>
              </v-card-text>
            </v-card>
          </v-dialog>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import ValidationRules from '@/plugins/mixins/ValidationRules';
import { getInternational } from '@/components/telephone/telephoneUtil.js';
import toasted from '@/utils/toasted';

export default {
  mixins: [ValidationRules],
  props: {
    typeObjet: {
      type: String,
    },
    modeEnvoi: {
      type: String,
    },
    selectedContacts: {
      type: Array,
    },
    recherche: {
      type: Array,
    },
    nbContacts: {
      type: Number,
      default: 0,
    },
  },
  beforeCreate() {},
  created() {},
  beforeMount() {},
  mounted() {},
  beforeUpdate() {},
  updated() {},

  data() {
    const headers = [
      {
        value: 'nom',
        sortable: true,
        text: this.$t(
          'recherche.rechercheSimple.personnePhysique.list.headers.nom',
        ),
      },
      {
        value: 'prenoms',
        sortable: true,
        text: this.$t(
          'recherche.rechercheSimple.personnePhysique.list.headers.prenoms',
        ),
      },
      {
        value: 'raisonSociale',
        sortable: true,
        text: this.$t(
          'recherche.rechercheSimple.personnePhysique.list.headers.personneMorale',
        ),
      },
      {
        value: 'fonction',
        sortable: true,
        text: this.$t(
          'recherche.rechercheSimple.personnePhysique.list.headers.fonction',
        ),
      },
      {
        value: 'telephone',
        sortable: false,
        text: this.$t(
          'recherche.rechercheSimple.personnePhysique.list.headers.telephone',
        ),
      },
      {
        value: 'mail',
        sortable: false,
        text: this.$t(
          'recherche.rechercheSimple.personnePhysique.list.headers.mail',
        ),
      },
      {
        value: 'status',
        sortable: false,
        text: this.$t('recherche.envoi.form.list.headers.status'),
        align: 'center',
      },
    ];
    return {
      headers,
      typesEnvoi: ['sms', 'mail'],
      // Affichage de la boîte de dialogue
      showDialog: false,
      // Boîte de dialogue opur l'envoi
      waitForSending: false,
      destinataires: [],
      form: {
        subject: '',
        body: '',
        typeEnvoi: 'sms',
      },
    };
  },
  computed: {
    subjectVisible() {
      return this.form.typeEnvoi === 'mail';
    },
    sendDisabled() {
      return this.nbContacts === 0 || !this.recherche;
    },
  },
  watch: {},
  methods: {
    getInternational,
    open(typeEnvoi) {
      this.form.typeEnvoi = typeEnvoi;
      this.showDialog = true;
      this.loadDestinataires();
    },
    loadDestinataires() {
      let contactIds = [];
      if (
        Array.isArray(this.selectedContacts) &&
        this.selectedContacts.length > 0
      ) {
        contactIds = this.selectedContacts.flatMap(c => c.id);
        this.$api('envoi/destinataires/list')
          .post({
            typeEnvoi: this.form.typeEnvoi,
            typeObjet: 'contact',
            contactIds: contactIds,
          })
          .then(response => {
            this.destinataires = [];
            this.destinataires.push(
              ...response.body.map(d => ({ ...d, status: 'none' })),
            );
          });
      }
    },
    close() {
      this.showDialog = false;
    },
    quit() {
      this.close();
    },
    send() {
      let contactIds = [];
      if (
        Array.isArray(this.selectedContacts) &&
        this.selectedContacts.length > 0
      ) {
        this.waitForSending = true;
        contactIds = this.selectedContacts.flatMap(c => c.id);
        this.$api('envoi/destinataires/send')
          .post({
            typeEnvoi: this.form.typeEnvoi,
            typeObjet: 'contact',
            contactIds: contactIds,
            objet: this.form.subject,
            message: this.form.body,
          })
          .then(response => {
            // Résultat global
            if (response.body.globalStatus) {
              switch (response.body.globalStatus) {
                case 'ok':
                  toasted.info('recherche.envoi.results.ok');
                  break;
                case 'ko':
                  if (response.body.message) {
                    toasted.error(
                      'recherche.envoi.results.error.' + response.body.message,
                    );
                  } else {
                    toasted.error('recherche.envoi.results.error.default');
                  }
                  break;
                case 'partiel':
                  toasted.info('recherche.envoi.results.partiel');
                  break;
                case 'noop':
                  toasted.info('recherche.envoi.results.noop');
                  break;
              }
            } else {
              toasted.error('recherche.envoi.results.error.default');
            }
            // Résultats individuels
            if (response.body.status) {
              this.destinataires.forEach(d => {
                if (response.body.status[d.id] === true) {
                  d.status = 'ok';
                } else if (response.body.status[d.id] === false) {
                  d.status = 'ko';
                } else {
                  d.status = 'unknown';
                }
              });
            }
          })
          .finally(() => {
            this.waitForSending = false;
          });
      }
    },
  },
};
</script>
